export const STORE_PLATFORMS = ['steam', 'epic', 'itch', 'gog'] as const;

export type StorePlatform = (typeof STORE_PLATFORMS)[number];

export const STORE_PLATFORM_LABELS: Readonly<Record<StorePlatform, string>> = Object.freeze({
  steam: 'Steam',
  epic: 'Epic Games Store',
  itch: 'itch.io',
  gog: 'GOG',
});

export function storePlatformLabel(platform: StorePlatform): string {
  return STORE_PLATFORM_LABELS[platform];
}

/**
 * What each platform is called where there is no room for its full name.
 *
 * `Epic Games Store` is the reason this exists: it is three words on a button
 * that has to sit beside two others inside a 300px block in the open case.
 * Epic's own storefront calls itself `Epic Games` in that position, so this is
 * shortening rather than renaming.
 */
export const STORE_PLATFORM_SHORT: Readonly<Record<StorePlatform, string>> = Object.freeze({
  steam: 'Steam',
  epic: 'Epic',
  itch: 'itch.io',
  gog: 'GOG',
});

export function storePlatformShort(platform: StorePlatform): string {
  return STORE_PLATFORM_SHORT[platform];
}

export const STORE_PLATFORM_ORDER: readonly StorePlatform[] = STORE_PLATFORMS;

export interface StoreLink {
  platform: StorePlatform;
  url: string;
}

export function orderedStoreLinks(links: readonly StoreLink[]): StoreLink[] {
  return [...links].sort(
    (left, right) =>
      STORE_PLATFORM_ORDER.indexOf(left.platform) - STORE_PLATFORM_ORDER.indexOf(right.platform),
  );
}
